import Home from "screens/Home";
import Privacy from "screens/Privacy";
import DeleteAccount from "screens/DeleteAccount";

export const routes = {
  HOME: {
    path: "/",
    name: "home",
    title: "homeTitle",
    component: Home,
    exact: true,
  },
  PRIVACY: {
    path: "/privacy",
    name: "privacy",
    title: "privacyTitle",
    component: Privacy,
    showInMenu: true,
    noIndex: true,
  },
  DATA_DELETION: {
    path: "/data-deletion",
    name: "deleteData",
    title: "deleteDataTitle",
    component: DeleteAccount,
    showInMenu: true,
    noIndex: true,
  },
};
